import { ActionTree } from 'vuex';
import AppState from '@/store/modules/app/types/AppState';
import RootState from '@/store/types/IRootState';

const actions: ActionTree<AppState, RootState> = {
  changeLocale(context, locale: string): void {
    context.commit('locale', locale);
  },
};

export default actions;
